import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import Main from "./components/main/Main";
import Buttons from './components/Buttons';
import Filters from './components/Filters';
import CardSlider from './components/CardSlider';
import PageDetails from './components/detail/PageDetails';
import Services from './components/Services';
import AboutCompany from './components/AboutCompany';
import Employees from './components/Employees';
import VideoReviews from './components/VideoReviews'
import Footer from "./components/Footer";
import Notification from "./components/utils/Notification";
import AdBlog from "./components/AdBlog";
import Seo from "./components/utils/Seo";
import {useRegister} from "./components/stores/authStore";

const App = () => {
    const {initAuth} = useRegister();

    useEffect(() => {
        initAuth();
    }, []);

    return (
        <Routes>
            <Route path="/" element={
                <div>
                    <Seo
                        title="Aluu Satuu — Агентство недвижимости в Кыргызстане"
                        description="Купить, продать или арендовать недвижимость в Кыргызстане. Актуальные предложения, экспертное сопровождение и безопасные сделки."
                        url={typeof window !== 'undefined' ? window.location.origin + '/' : '/'}
                        image={'/image.png'}
                    />
                    <Main/>
                    <Buttons/>
                    <Filters/>
                    <CardSlider/>
                    <AdBlog/>
                    <AboutCompany/>
                    <Services/>
                    <VideoReviews/>
                    <Employees/>
                    {/*<ContactUs/>*/}
                    <Footer/>
                    <Notification/>
                </div>
            }/>
            <Route path="/detail/*" element={<PageDetails/>}/>
        </Routes>
    );
};

export default App;